// extracted by mini-css-extract-plugin
module.exports = {"form":"Form__form","formControl":"Form__formControl","formRow":"Form__formRow","formExtra":"Form__formExtra"};